export enum PrizeDrawTypeEnum {
  MULTIPLE_CHOICE = 'MULTIPLA_ESCOLHA',
  PRIZE_WHEEL = 'RODA_PREMIOS',
  SCRATCH_CARD = 'RASPADINHA',
  THEMATIC_WHEEL = 'RODA_TEMATICA',
}
